import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../services/api";

export const fetchModelProducts = createAsyncThunk(
  "model/fetchModelProducts",
  async ({ category, model, selectedSeriesId }, { rejectWithValue }) => {
    try {
      const response = await api.getBrandProducts(category, model);
      return response.data || response;
    } catch (err) {
      return rejectWithValue(err.message || "Failed to load products");
    }
  },
);

const initialState = {
  data: null,
  category: null,
  brand: null,
  series: [],
  products: [],
  loading: false,
  error: null,
  selectedSeriesId: null,
};

const modelSlice = createSlice({
  name: "model",
  initialState,
  reducers: {
    clearModelData: (state) => {
      Object.assign(state, initialState);
    },
    setSelectedSeriesId: (state, action) => {
      state.selectedSeriesId = action.payload;
    },
    clearSelectedSeriesId: (state) => {
      state.selectedSeriesId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchModelProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchModelProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.category = action.payload?.category || null;
        state.brand = action.payload?.brand || null;
        state.series = action.payload?.series || [];
        state.products = action.payload?.products || [];
      })
      .addCase(fetchModelProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.data = null;
        state.category = null;
        state.brand = null;
        state.series = [];
        state.products = [];
      });
  },
});

export const { clearModelData, setSelectedSeriesId, clearSelectedSeriesId } =
  modelSlice.actions;
export default modelSlice.reducer;
